import React, { useEffect, useState } from "react";
import ProfileBackground from "../../../assets/images/profile-background.png";
import ProfileImage from "../../../assets/images/profile-image.png";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import { data } from "react-router-dom";

const MyProfile = () => {
  const [userData, setUserData] = useState({});
  const [role, setRole] = useState("");
  const fetchUserDetails = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_MY_PROFILE_DATA,
      });
      const data = response.data;

      if (response.success) {
        const updatedUser = {
          name: data.name,
          email: data.email,
          status: data.status,
          phoneNumber: data.contact_no,
          role: data.role,
        };
        setUserData(updatedUser);
        fetchRoles(data.role); // Pass role ID to fetchRoles
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const fetchRoles = async (roleId) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.ALL_ROLES,
      });

      if (response.success) {
        const roles = response?.data?.docs || [];
        const matchedRole = roles.find((item) => item._id === roleId);
        if (matchedRole) {
          setRole(matchedRole.Role);
        }
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  return (
    <div style={{ backgroundColor: "#fff" }} className="my-2">
      <div className="px-4">
        <div
          style={{
            backgroundImage: `url(${ProfileBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="h-52 px-4 relative rounded-lg"
        >
          <img
            src={ProfileImage}
            alt="Profile"
            className="absolute bottom-[-50px] left-6 w-24 h-24 object-cover rounded-full border-4 border-white"
          />
        </div>
      </div>
      <div className="px-36 ">
        <p className=" text-2xl">{userData.name}</p>
        {/* <p className="mt-[10px] font-light">OGT124</p> */}
      </div>
      <div
        style={{
          //borderTop: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
          backgroundColor: "#fff",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            borderTop: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
            backgroundColor: "#fff",
            paddingBottom: "18px",
          }}
        >
          <div className="px-10">
            <h4 className="text-xl">Basic Information</h4>

            <div className="flex flex-wrap justify-between gap-5 mb-6">
              {/* Left Section */}
              <div className="flex-1 min-w-[250px] ">
                <div className="mb-10">
                  <label className="block font-semibold text-gray-500">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    disabled
                    value={userData.name}
                    className="w-full max-w-lg p-2 border-b focus:outline-none"
                  />
                </div>

                <div className="">
                  <label className="block font-semibold text-gray-500">
                    Contact
                  </label>
                  <input
                    type="text"
                    name="contact"
                    value={userData.phoneNumber}
                    disabled
                    className="w-full max-w-lg p-2 border-b focus:outline-none"
                  />
                </div>
              </div>

              {/* Right Section */}
              <div className="flex-1 min-w-[250px]">
                {/* <div className="mb-6">
                  <label className="block font-semibold text-gray-500">
                    Username
                  </label>
                  <input
                    type="text"
                    name="username"
                    className="w-full max-w-lg p-2 border-b focus:outline-none"
                  />
                </div> */}

                <div className="mb-10">
                  <label className="block font-semibold text-gray-500">
                    Role
                  </label>
                  <input
                    type="text"
                    name="role"
                    value={role}
                    disabled
                    className="w-full max-w-lg p-2 border-b focus:outline-none"
                  />
                </div>
                <div className="mb-6">
                  <label className="block font-semibold text-gray-500">
                    Email ID
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={userData.email}
                    disabled
                    //value={basicInformation.contactNumber_1}
                    //onChange={handleChange}
                    className="w-[500px] p-2 border-b focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="px-10">
            <div>
              {/* Contact Details 1 */}
              <div className="flex justify-between gap-5 mb-6"></div>

              {/* Contact Details 2 */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
